import * as _ from 'underscore';

import { DatasourceSubspaceName } from '../../state/SpaceInfo';
import { SpaceConfigHelper } from './SpaceConfigHelper';

export namespace DatasourceSpaceConfigHelper {

  export interface DatasourceSubspace {
    name: DatasourceSubspaceName;
    stateSuffix: string;
    urlSuffix: string;
  }

  export const DatasourceSubspaces: DatasourceSubspace[] = [
    {
      name: 'nlp',
      stateSuffix: 'nlp',
      urlSuffix: 'askData',
    },
    {
      name: 'connections',
      stateSuffix: 'connections',
      urlSuffix: 'connections',
    },
    {
      name: 'extractRefreshes',
      stateSuffix: 'extractTasks',
      urlSuffix: 'extractRefreshes',
    },
    {
      name: 'remoteRefreshSchedules',
      stateSuffix: 'remoteRefreshSchedules',
      urlSuffix: 'localExtractRefreshes',
    },
    {
      name: 'connectedWorkbooks',
      stateSuffix: 'connectedWorkbooks',
      urlSuffix: 'connectedWorkbooks',
    },
    {
      name: 'lineage',
      stateSuffix: 'lineage',
      urlSuffix: 'lineage',
    },
    {
      name: 'askDataUsageAnalytics',
      stateSuffix: 'askDataUsageAnalytics',
      urlSuffix: 'askDataUsageAnalytics',
    },
  ];

  export function subspaceNameFromCurrentState(currentState: ng.ui.IState): DatasourceSubspaceName | undefined {
    if (currentState.data && currentState.data.subplaceName) {
      return currentState.data.subplaceName;
    }
    const stateName = currentState.name;
    const isDatasourceSpace = stateName.startsWith('main.site.content.datasource');
    const stateSuffix: string = SpaceConfigHelper.currentStateSuffix(currentState);
    const subspace = _(DatasourceSubspaces).findWhere({ stateSuffix });
    return isDatasourceSpace && subspace && subspace.name || undefined;
  }

  export function urlSuffixFromSubspaceName(subspaceName: DatasourceSubspaceName): string | undefined {
    const subspace = _(DatasourceSubspaces).findWhere({ name: subspaceName });
    return subspace && subspace.urlSuffix || undefined;
  }
}
